import { Component, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RouterLink } from "@angular/router";
import { SlicePipe } from '@angular/common';

import { BlogPost } from '../../services/blog.service';

@Component({
  selector: 'app-blog-item',
  imports: [DatePipe, RouterLink, SlicePipe],
  templateUrl: './blog-item.html',
  styleUrl: './blog-item.scss',
})
export class BlogItem {
  @Input() post!: BlogPost;
  @Input() index!: number;
}
